import Alert from "../components/alert";
import classes from "../classes";
import { Link } from "react-router-dom";
import React from "react";

export default class LoginForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.login = this.login.bind(this);
  }

  componentDidMount() {
    if (window.env.customLoginLinks) {
      return;
    }
    this.refs.email.focus();
  }

  login(e) {
    var { onLogin } = this.props;
    e.preventDefault();
    let email = this.refs.email.value;
    let password = this.refs.password.value;
    let rememberMe = this.refs.rememberMe.checked;
    onLogin(email, password, rememberMe);
  }

  render() {
    if (window.env.customLoginLinks) {
      return (
        <div>
          Your session has expired. Please return to the main site to login.
          {" "}

          <a className="btn btn--primary" href={window.env.customLoginLinks.login}>
            Login
          </a>
        </div>
      );
    }

    var { errorMessage, loading } = this.props;
    var alertBox = (errorMessage) ? <Alert icon="dw-blocked" title={errorMessage} type="notification--error" /> : null;
    var loginClasses = classes({
      "btn": true,
      "btn--primary": true,
      "btn--is-loading": loading
    });

    return (
      <form className="form--is-horizontal" onSubmit={this.login}>
        {alertBox}

        <div className="batch-g batch-g--padding batch-g--valign-center">
          <div className="batch-c-1-1 batch-c-md-5-24">
            <label htmlFor="email">
              Email Address
            </label>
          </div>

          <div className="batch-c-1-1 batch-c-md-19-24">
            <input className="form_input" name="email" placeholder="Email Address" ref="email" type="email" />
          </div>

          <div className="batch-c-1-1 batch-c-md-5-24">
            <label htmlFor="password">
              Password
            </label>
          </div>

          <div className="batch-c-1-1 batch-c-md-19-24">
            <input className="form_input" name="password" placeholder="Password" ref="password" type="password" />
          </div>

          <div className="batch-c-1-1 batch-c-md-5-24" />

          <div className="batch-c-1-1 batch-c-md-19-24">
            <div className="form_action">
              <input className={loginClasses} disabled={loading} type="submit" value="Log In" />

              <span className="form_note">
                <label>
                  <input defaultChecked="checked" name="remember-me" ref="rememberMe" type="checkbox" />

                  {" "}
                  Keep me logged in.
                </label>
              </span>

              <span>
                <Link className="text-small display--is-block-mobile" to="/password-reset">
                  Forgot password?
                </Link>
              </span>
            </div>
          </div>
        </div>
      </form>
    );
  }
}
